import * as React from 'react';
import {useSelector} from 'react-redux';

import {selectCorporateLabels} from 'src/selectors/language-support';
import {selectEntityMappingsBySenseName} from 'src/selectors/ats-entities';

import {FilterCard} from './';
import Checkbox from 'src/components/lib/checkbox/index';

import css from './recipient-card.css';

import useLabelTranslation from 'src/hooks/useLabelTranslation';


type Props = {
  onSave?: (e: React.SyntheticEvent) => unknown;
  onCancel?: (e: React.SyntheticEvent) => unknown;
  onRecipientTypeChange: (e: React.SyntheticEvent<HTMLInputElement>) => unknown;
  selectedRecipientTypes: string[];
  recipientTypes?: {
    value: string;
    label: string;
    sense_name: string;
  }[];
};

const getTranslatedRecipientTypes = (
  t: (key: string, defaultMessage: string) => string,
  corporateLabels: any,
) => {
  const defaultRecipientTypes = [
    {
      value: 'audience_member',
      label: t(corporateLabels['sense_candidate'], 'Candidate'),
      sense_name: 'candidate',
    },
    {
      value: 'client',
      label: t(corporateLabels['sense_contact'], 'Contact'),
      sense_name: 'client_company_employee',
    },
    {
      value: 'internal',
      label: t(corporateLabels['sense_internal_employee'], 'Internal Employee'),
      sense_name: 'internal_employee',
    },
  ];
  return defaultRecipientTypes;
};

const RecipientCard = ({
  onSave,
  onCancel,
  recipientTypes,
  onRecipientTypeChange,
  selectedRecipientTypes = [],
  // @ts-expect-error - TS2339 - Property 'cardLabel' does not exist on type 'Props'.
  cardLabel = '',
}: Props) => {
  const {t, makeKey} = useLabelTranslation();
  const cardLabelText = cardLabel || t('Recipient', 'Recipient');
  const corporateLabels = useSelector(selectCorporateLabels);

  const translatedRecipientTypes =
    recipientTypes || getTranslatedRecipientTypes(t, corporateLabels);

  const atsEntities = useSelector(selectEntityMappingsBySenseName);
  const filteredRecipientTypes = translatedRecipientTypes.filter(
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<EntitySenseName, AtsEntity>>'.
    (recipient) => atsEntities[recipient.sense_name],
  );

  return (
    <FilterCard header={cardLabelText} onSave={onSave} onCancel={onCancel}>
      <section className={css.section}>
        <ul className={css.checklist}>
          {filteredRecipientTypes.map(({value, label}) => (
            <li key={value}>
              <label className={css.label}>
                <Checkbox
                  className={css.checkbox}
                  name={value}
                  checked={selectedRecipientTypes.includes(value)}
                  onChange={onRecipientTypeChange}
                />
                {t(makeKey(label), label)}
              </label>
            </li>
          ))}
        </ul>
      </section>
    </FilterCard>
  );
};

export default RecipientCard;
